import { URLs } from "@/constants";
import type { IApp } from "@/types";
import { apiURL, sendRequest } from "@/utils";

namespace Profile {
  export const get = async () => {
    return await sendRequest<{
      profile: IApp.IProfile;
      prompts: Array<IApp.IPrompt>;
      defaultPrompt: string;
    }>({
      url: apiURL(URLs.API_PROFILE_GET),
      method: "GET"
    });
  };

  export const update = async (data: Partial<IApp.IProfile>) => {
    return await sendRequest<{
      profile: IApp.IProfile;
      prompts: Array<IApp.IPrompt>;
      defaultPrompt: string;
    }>({
      url: apiURL(URLs.API_PROFILE_UPDATE),
      method: "PATCH",
      data: data
    });
  };

  export const createPrompt = async (data: Omit<IApp.IPrompt, "id">) => {
    return await sendRequest<{ prompt: IApp.IPrompt }>({
      url: apiURL(URLs.API_PROFILE_PROMPT_CREATE),
      method: "POST",
      data: data
    });
  };

  export const getPrompt = async (id: string) => {
    return await sendRequest<{ prompt: IApp.IPrompt }>({
      url: apiURL(URLs.API_PROFILE_PROMPT_GET(id)),
      method: "GET"
    });
  };

  export const updatePrompt = async (data: IApp.IPrompt) => {
    return await sendRequest<{ prompt: IApp.IPrompt }>({
      url: apiURL(URLs.API_PROFILE_PROMPT_UPDATE(data.id)),
      method: "PATCH",
      data: data
    });
  };

  export const deletePrompt = async (id: string) => {
    return await sendRequest<void>({
      url: apiURL(URLs.API_PROFILE_PROMPT_DELETE(id)),
      method: "DELETE"
    });
  };
}

export default Profile;
